var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#01447a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m618.75 228.15h-37.5l18.75-228.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1162.5 1200h-1125c-20.727 0-37.5-16.789-37.5-37.5s16.773-37.5 37.5-37.5h1125c20.727 0 37.5 16.789 37.5 37.5s-16.773 37.5-37.5 37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m718.83 690.23c-41.254-188.7-43.832-427.73-43.832-427.73l-75-112.5-75 112.5s-2.5781 239.04-43.832 427.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m748.03 765.23h-296.05c-37.73 67.707-127.67 220.2-264.47 397.27h225c0-103.55 83.945-187.5 187.5-187.5s187.5 83.945 187.5 187.5h225c-136.8-177.07-226.74-329.56-264.47-397.27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.61b6755c25b3c418ee0c05393f136ad0.svg";
export { ForwardRef as ReactComponent };